import { fallbackPages } from '../data';

/**
 * Fetches page content from the CMS pages collection by page_slug.
 * Falls back to local mock data if the request fails.
 * 
 * @param {string} pageSlug - The slug of the page to fetch ('home', 'om-os', 'kontakt')
 * @returns {Promise<object>} The page data object
 */
export async function fetchPageContent(pageSlug) {
  try {
    const response = await fetch(`https://api.dev.auxo.dk/public/v2/content/pages?page_slug=${pageSlug}`);
    if (!response.ok) {
      throw new Error(`CMS returned status ${response.status}`);
    }
    const data = await response.json();
    
    // Check if we got items back
    if (data && data.items && data.items.length > 0) {
      const item = data.items[0];
      // Map the CMS fields to our expected shape
      return {
        page_slug: item.page_slug || pageSlug,
        title: item.title || fallbackPages[pageSlug].title,
        meta_title: item.meta_title || fallbackPages[pageSlug].meta_title,
        meta_description: item.meta_description || fallbackPages[pageSlug].meta_description,
        hero_title: item.hero_title || fallbackPages[pageSlug].hero_title,
        hero_text: item.hero_text || fallbackPages[pageSlug].hero_text,
        content: item.content || fallbackPages[pageSlug].content,
        images: item.images || fallbackPages[pageSlug].images
      };
    }
    
    console.warn(`No CMS content found for slug "${pageSlug}". Using fallback data.`);
    return fallbackPages[pageSlug];
  } catch (error) {
    console.error(`Error fetching CMS content for slug "${pageSlug}":`, error);
    return fallbackPages[pageSlug];
  }
}
